import { useEffect, useRef } from 'react';
import { ADSENSE_CLIENT_ID, ADSENSE_BLOG_LIST_SLOT } from '../../config/adsense';
import './AdUnits.css';

const DisplayAd = ({ slot = ADSENSE_BLOG_LIST_SLOT, label = 'Advertisement' }) => {
  const pushedRef = useRef(false);
  const adSlot = slot || ADSENSE_BLOG_LIST_SLOT;

  useEffect(() => {
    if (!adSlot || pushedRef.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushedRef.current = true;
    } catch (e) {
      console.warn('Display AdSense push failed:', e);
    }
  }, [adSlot]);

  if (!adSlot) {
    return null;
  }

  return (
    <div className="adsense-unit adsense-unit--display" aria-label={label}>
      <span className="adsense-label">{label}</span>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_CLIENT_ID}
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default DisplayAd;
